// src/utils/fxhash.js
export async function fetchFxhashArtwork(id) {
  const response = await fetch(`https://api.fxhash.xyz/v1/artworks/${id}`);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await response.json();
  return data;
}
